import {
  Box,
  Container,
  Typography,
  TextField,
  InputAdornment,
  Button,
  Stack,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";

import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";

import { motion } from "framer-motion";

const aparecer = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * .15,
      duration: .8,
    },
  }),
};

export const HeroNoticias =  ({
buscar,
setBuscar

})=>{
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        background: "#fff",
        pt: {
          xs: 13,
          md: 18,
        },
        pb: {
          xs: 8,
          md: 12,
        },
      }}
    >
      {/* Fondo degradado */}

      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at top right,rgba(72,74,117,.05),transparent 45%)",
        }}
      />

      {/* Puntos */}

      <Box
        sx={{
          position: "absolute",
          right: {
            xs: -20,
            md: 80,
          },
          top: 80,

          width: 170,
          height: 170,

          opacity: .6,

          backgroundImage:
            "radial-gradient(circle,#C62828 2px,transparent 2px)",

          backgroundSize: "16px 16px",

          maskImage:
            "radial-gradient(circle at center,black 45%,transparent 100%)",

          WebkitMaskImage:
            "radial-gradient(circle at center,black 45%,transparent 100%)",
        }}
      />

      {/* Mancha */}

      <Box
        sx={{
          position: "absolute",
          right: -180,
          top: -120,

          width: 520,
          height: 520,

          borderRadius: "50%",

          background:
            "radial-gradient(circle,rgba(72,74,117,.08),transparent 70%)",
        }}
      />

      <Container maxWidth="lg">

        <motion.div
          variants={aparecer}
          initial="hidden"
          animate="visible"
          custom={0}
        >
          <Typography
            sx={{
              color: "#C62828",
              fontWeight: 700,
              letterSpacing: 2,
              textTransform: "uppercase",
              fontFamily: "Archivo",
            }}
          >
            Noticias
          </Typography>
        </motion.div>

        <Box
          sx={{
            width: 70,
            height: 3,
            bgcolor: "#C62828",
            borderRadius: 5,
            my: 2,
          }}
        />

        <motion.div
          variants={aparecer}
          initial="hidden"
          animate="visible"
          custom={1}
        >
          <Typography
            sx={{
              fontFamily: "Archivo",
              color: "#12213F",
              fontWeight: 700,
              lineHeight: 1,

              fontSize: {
                xs: "2.6rem",
                md: "4.5rem",
              },

              maxWidth: 760,
            }}
          >
            Mantente informado de todo lo que ocurre en nuestro colegio
          </Typography>
        </motion.div>

        <motion.div
          variants={aparecer}
          initial="hidden"
          animate="visible"
          custom={2}
        >
          <Typography
            sx={{
              mt: 3,
              color: "#6B7280",
              fontSize: {
                xs: 16,
                md: 20,
              },
              maxWidth: 760,
              lineHeight: 1.7,
            }}
          >
            Comunicados, actividades, matrículas, eventos y todas las
            novedades de la comunidad educativa del Colegio Antilén.
          </Typography>
        </motion.div>

        {/* Buscador */}

        <motion.div
          variants={aparecer}
          initial="hidden"
          animate="visible"
          custom={3}
        >
          <Stack
            direction={{
              xs: "column",
              md: "row",
            }}
            spacing={2}
            sx={{
              mt: 6,
            }}
          >
            <TextField
              fullWidth
              placeholder="Buscar noticias..."
              sx={{
                maxWidth: 600,

                "& .MuiOutlinedInput-root": {
                  borderRadius: "18px",
                  background: "#fff",

                  "& fieldset": {
                    borderColor: "#E5E7EB",
                  },

                  "&:hover fieldset": {
                    borderColor: "#484a75",
                  },

                  "&.Mui-focused fieldset": {
                    borderColor: "#484a75",
                  },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#484a75" }} />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="contained"
              startIcon={<SearchIcon />}
              sx={{
                borderRadius: "18px",
                px: 4,
                height: 56,

                background:
                  "linear-gradient(135deg,#C62828,#8f1515,#484a75)",

                textTransform: "none",

                fontWeight: 700,

                "&:hover": {
                  background:
                    "linear-gradient(135deg,#8f1515,#561c33,#484a75)",
                },
              }}
            >
              Buscar
            </Button>
          </Stack>
        </motion.div>

        {/* Indicadores */}

        <motion.div
          variants={aparecer}
          initial="hidden"
          animate="visible"
          custom={4}
        >
          <Stack
            direction={{
              xs: "column",
              sm: "row",
            }}
            spacing={3}
            sx={{
              mt: 6,
            }}
          >
           
            <Stack direction="row" spacing={1} alignItems="center">
              <LocalOfferOutlinedIcon sx={{ color: "#C62828" }} />

              <Typography
                sx={{
                  color: "#484a75",
                  fontWeight: 600,
                }}
              >
                Comunicados · Eventos · Matrículas
              </Typography>
            </Stack>
          </Stack>
        </motion.div>

      </Container>
    </Box>
  );
};